import { textAngularConfig } from './helper/textAngular.config';
import { routes } from './helper/routes';

appConfig.$inject = [
	'$routeProvider',
	'$httpProvider',
	'$locationProvider',
	'$provide',
	'ScrollBarsProvider',
	'$analyticsProvider',
	'$sceDelegateProvider'
];

export function appConfig(
	$routeProvider,
	$httpProvider,
	$locationProvider,
	$provide,
	ScrollBarsProvider,
	$analyticsProvider,
	$sceDelegateProvider
) {
	$sceDelegateProvider.resourceUrlWhitelist(['self', `${window.baseURL}/**`]);

	for (const path in routes) {
		routes[path].resolve = {
			user: [
				'routeResolver',
				function(routeResolver) {
					return routeResolver.resolve();
				}
			]
		};

		if (routes[path].controller === 'CalendarController') {
			routes[path].reloadOnSearch = false;
		}

		$routeProvider.when(path, routes[path]);
	}

	ScrollBarsProvider.defaults = {
		// setHeight: 200,
		scrollButtons: {
			scrollAmount: 'auto', // scroll amount when button pressed
			enable: false // enable scrolling buttons by default
		},
		advanced: {
			updateOnContentResize: true
		},
		theme: 'dark-ninja',
		autoHideScrollbar: false,
		scrollInertia: 0,
		axis: 'x' // enable 2 axis scrollbars by default
	};

	$routeProvider.otherwise({ redirectTo: '/' });
	$locationProvider.html5Mode({ enabled: true, requireBase: false });

	$httpProvider.defaults.withCredentials = true;

	$httpProvider.interceptors.push([
		'$q',
		'$location',
		'$injector',
		'authTokensService',
		'accountService',
		function($q, $location, $injector, authTokensService, accountService) {
			return {
				request(req) {
					const token = authTokensService.getAuthToken();
					return addToken(req, token);
				},

				responseError(rejection) {
					const defer = $q.defer();

					if (rejection.status === 400) {
						handle400Error(rejection, defer);
					} else if (rejection.status === 401) {
						return handle401Error(rejection, defer);
					} else if (rejection.status === 403) {
						handle403Error(defer);
					} else {
						defer.reject(rejection);
					}
					return defer.promise;
				}
			};

			function handle400Error(err, defer) {
				if (
					err &&
					err.data &&
					err.data.error_description &&
					err.data.error_description.startsWith('Invalid refresh token')
				) {
					return logout();
				}
				return defer.reject(err);
			}

			function handle401Error(err, defer) {
				const isInvalidAccessToken =
					err &&
					err.data &&
					err.data.error &&
					err.data.error === 'invalid_token';
				const isInvalidRefreshToken =
					err &&
					err.data &&
					err.data.error_description &&
					err.data.error_description.startsWith('Invalid refresh token');

				if (isInvalidRefreshToken) {
					return logout();
				}

				if (isInvalidAccessToken) {
					if (!authTokensService.isRefreshingInProcess()) {
						authTokensService.setRefreshingInProcess(true);
						authTokensService.emitTokenSubject(null);

						const refreshToken = authTokensService.getRefreshToken();
						if (!refreshToken) {
							return logout();
						}

						return accountService
							.getRefreshedAuthTokenWeb(refreshToken)
							.switchMap(tokensData => {
								if (!tokensData) {
									return logout();
								}
								const refreshToken = authTokensService.successGetRefreshedToken(
									tokensData
								);
								return Rx.Observable.of(refreshToken);
							})
							.switchMap(authToken => {
								if (!authToken) {
									return logout();
								}
								authTokensService.emitTokenSubject(authToken);
								const $http = $injector.get('$http');
								return $http(addToken(err.config, authToken));
							})
							.toPromise()
							.catch(err => defer.reject(err))
							.finally(() => {
								authTokensService.setRefreshingInProcess(false);
							});
					}

					return authTokensService.tokenSubject
						.filter(authToken => authToken !== null)
						.take(1)
						.switchMap(authToken => {
							const $http = $injector.get('$http');
							return $http(addToken(err.config, authToken));
						});
				}
			}

			function handle403Error(defer) {
				if (!$location.path().includes('subscription')) {
					$location.path('/subscription');
					return defer.resolve(rejection);
				}
			}

			function addToken(req, token) {
				if (authTokensService.isToken(req.url, token)) {
					req.headers.Authorization = `Bearer ${token}`;
				}
				return req;
			}

			function logout() {
				return accountService.successLogoutWeb();
			}
		}
	]);

	(function($) {
		$(document).ready(() => {
			const dropdownMenuClass = '.dropdown-menu',
				DELAY = 400;

			$(document).on('show.bs.dropdown', '.dropdown.slide', function() {
				$(this)
					.find(dropdownMenuClass)
					.first()
					.stop(true, true)
					.slideDown(DELAY);
			});

			$(document).on('hide.bs.dropdown', '.dropdown.slide', function() {
				$(this)
					.find(dropdownMenuClass)
					.first()
					.stop(true, true)
					.slideUp(DELAY);
			});
		});
	})(window.jQuery);

	$provide.decorator('$exceptionHandler', [
		'$delegate',
		'$injector',
		function($delegate, $injector) {
			return function(exception, cause) {
				$delegate(exception, cause);
				console.error(exception, cause);

				const rScope = $injector.get('$rootScope');
				if (rScope) {
					rScope.crashedTextAngular = true;
				}
			};
		}
	]);

	$provide.decorator('taOptions', textAngularConfig);

	$analyticsProvider.virtualPageviews(false);
}



// WEBPACK FOOTER //
// ./web/js/app.config.js